export {
    default as TemplateCompany,
    ITemplateCompanyProps,
} from './company';
